import { configureStore } from '@reduxjs/toolkit';
import deviceAuthReducer from "./slice/deviceAuthSlice"

export const store = configureStore({
  reducer: {
    deviceAuth:deviceAuthReducer
  },
});
